
import React from 'react';

const STEPS = [
  {
    n: '1',
    title: 'Choisis ton activité',
    desc: 'Parcours plus de 200 activités indoor en Île-de-France. Filtre par catégorie, prix, distance, ou simplement par humeur.',
    numBg: 'bg-brand-primary-50',
    numColor: 'text-brand-primary',
  },
  {
    n: '2',
    title: 'Vote en groupe',
    desc: 'Invite tes potes à voter pour le créneau qui leur va. On retient automatiquement le moment où tout le monde est dispo.',
    numBg: 'bg-brand-secondary/8',
    numColor: 'text-brand-secondary',
  },
  {
    n: '3',
    title: 'Réserve et joue',
    desc: "Présentez-vous au lieu le jour J et profitez. Annulation gratuite jusqu'à 24 h avant. Promis, ça arrive.",
    numBg: 'bg-brand-success/10',
    numColor: 'text-brand-success',
  },
];

const HowItWorksSection = () => (
  <section className="max-w-[1280px] mx-auto px-4 sm:px-6 pt-10 sm:pt-20">
    <div className="bg-white rounded-3xl px-5 sm:px-12 py-10 sm:py-14">
      {/* Header */}
      <div className="mb-10">
        <h2 className="font-heading font-extrabold text-brand-dark tracking-tight leading-tight" style={{ fontSize: 'clamp(28px, 3vw, 40px)', letterSpacing: '-0.02em' }}>
          Comment ça marche&nbsp;?
        </h2>
        <p className="text-brand-text-muted mt-2 text-base">Trois étapes, zéro prise de tête.</p>
      </div>

      {/* Steps */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
        {STEPS.map(({ n, title, desc, numBg, numColor }) => (
          <div key={n}>
            <div className={`w-14 h-14 rounded-full ${numBg} ${numColor} flex items-center justify-center font-heading font-extrabold text-[22px] mb-4`}>
              {n}
            </div>
            <h4 className="font-heading font-bold text-[19px] text-brand-text mb-2">{title}</h4>
            <p className="text-[15px] leading-relaxed text-brand-text-muted">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorksSection;
